import React from 'react';
import { motion } from 'framer-motion';
import { Clock, RefreshCw, Users, BookOpen, Activity, LayoutGrid, Briefcase, Shield } from 'lucide-react';
export function FinalComparison() {
  const comparisons = [{
    icon: <Clock className="w-6 h-6" data-id="element-124" />,
    sin: '3-5 hs/semana planificando desde cero',
    con: '10 min/semana. El resto es entrenar.'
  }, {
    icon: <RefreshCw className="w-6 h-6" data-id="element-125" />,
    sin: 'Siempre los mismos ejercicios',
    con: '+60 sesiones distintas listas para usar'
  }, {
    icon: <Users className="w-6 h-6" data-id="element-126" />,
    sin: 'Jugadoras que abandonan sin saber por qué',
    con: 'Progresión → retención visible'
  }, {
    icon: <BookOpen className="w-6 h-6" data-id="element-127" />,
    sin: 'Sin estructura clara de semana a semana',
    con: '6 tomos con temporada completa resuelta'
  }, {
    icon: <Activity className="w-6 h-6" data-id="element-128" />,
    sin: 'Lesión en el plantel = pánico',
    con: 'Protocolo anti-lesiones listo para activar'
  }, {
    icon: <LayoutGrid className="w-6 h-6" data-id="element-129" />,
    sin: 'Niveles mezclados = caos en el entrenamiento',
    con: 'Variaciones por nivel en cada ejercicio'
  }, {
    icon: <Briefcase className="w-6 h-6" data-id="element-130" />,
    sin: 'Sin imagen profesional visible',
    con: 'Sistema que justifica cobrar más'
  }, {
    icon: <Shield className="w-6 h-6" data-id="element-131" />,
    sin: 'Sin trabajo específico para tu arquera',
    con: 'Megapack Porteras completo incluido'
  }];
  return <section className="py-10 md:py-20 px-4 bg-navy text-white" data-id="element-132">
      <div className="max-w-5xl mx-auto" data-id="element-133">
        <div className="text-center mb-8 md:mb-16" data-id="element-134">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-2xl md:text-5xl font-black mb-4 md:mb-6" data-id="element-135">
            El próximo lunes podés volver a improvisar la sesión. O podés entrar
            al campo con todo resuelto desde hoy.
          </motion.h2>
          <motion.h3 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl md:text-3xl font-bold text-brandGreen" data-id="element-136">
            ¿Cuánto cuesta NO tenerlo?
          </motion.h3>
        </div>

        <div className="bg-navy-light rounded-3xl border border-white/10 overflow-hidden shadow-2xl" data-id="element-137">
          {/* Header */}
          <div className="grid grid-cols-1 md:grid-cols-12 bg-navy-dark border-b border-white/10 p-4 md:p-6 hidden md:grid" data-id="element-138">
            <div className="md:col-span-1" data-id="element-139"></div>
            <div className="md:col-span-5 font-bold text-red-400 text-sm md:text-lg text-center" data-id="element-140">
              Sin Fútbol Femenino Resuelto
            </div>
            <div className="md:col-span-6 font-bold text-brandGreen text-sm md:text-lg text-center" data-id="element-141">
              Con Fútbol Femenino Resuelto
            </div>
          </div>

          {/* Rows */}
          <div className="divide-y divide-white/5" data-id="element-142">
            {comparisons.map((row, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="grid grid-cols-1 md:grid-cols-12 p-4 md:p-6 items-center gap-2 md:gap-0 hover:bg-white/5 transition-colors" data-id="element-143">
                <div className="md:col-span-1 flex justify-center text-gray-400 hidden md:flex" data-id="element-144">
                  {row.icon}
                </div>

                {/* Mobile labels */}
                <div className="md:hidden flex items-center gap-2 font-bold text-red-400 text-xs mb-1 mt-2" data-id="element-145">
                  <span className="text-gray-400" data-id="element-146">{row.icon}</span> Sin el
                  sistema:
                </div>
                <div className="md:col-span-5 flex items-center gap-3 text-gray-300 text-sm md:text-base md:pr-6 md:border-r border-white/10" data-id="element-147">
                  <span className="text-red-500 font-bold hidden md:inline" data-id="element-148">
                    Sin →
                  </span>
                  <span data-id="element-149">{row.sin}</span>
                </div>

                {/* Mobile labels */}
                <div className="md:hidden font-bold text-brandGreen text-xs mb-1 mt-3" data-id="element-150">
                  Con el sistema:
                </div>
                <div className="md:col-span-6 flex items-center gap-3 text-white font-medium text-sm md:text-base md:pl-6" data-id="element-151">
                  <span className="text-brandGreen font-bold hidden md:inline" data-id="element-152">
                    Con →
                  </span>
                  <span data-id="element-153">{row.con}</span>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}